import {
  ImpactHero,
  ImpactStats,
  ImpactAreas,
  StoriesOfChange,
} from '@/components/sections/impact-page'
import { FinalCTA } from '@/components/sections'
import { usePageTitle } from '@/hooks'

export const ImpactPage = () => {
  usePageTitle('Our Impact')

  return (
    <>
      <ImpactHero />
      <ImpactStats />
      <ImpactAreas />
      <StoriesOfChange />
      <FinalCTA />
    </>
  )
}
